module.exports = __webpack_public_path__ + "assets/img/home-selected-report-en.c8fa43bb.png";